module.exports = __webpack_public_path__ + "static/media/mz.aff3b04a.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mz.svg
// module id = 940
// module chunks = 0